<template>
    <div class="lm-viewport" :class="[loaded]" :style="viewportStyles">
        <slot :dimm="dimm"></slot>
    </div>
</template>

<script>
    export default {
        name: "TxProductViewport",
        data() {
            return {
                loaded: false,
                dimm: {
                    width: 0,
                    maxWidth: 0,
                    height: 0,
                    maxHeight: 0
                },
            }
        },
        watch: {
            dimm: {
                handler: function (newValue, oldValue) {
                    this.$emit('viewport-change', newValue)
                },
                deep: true,
            }
        },
        computed: {
            viewportStyles() {
                if (this.dimm.maxHeight) {
                    let test = {
                        height: `${this.dimm.height}px`,
                    }
                    console.log(test);
                    return test;
                } else {
                    return {}
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.setViewportContainerDim();

            })
            this._interval = setInterval(() => {
                this.setViewportContainerDim()
            }, 2000);
            window.addEventListener('resize', () => {
                this.$nextTick(() => {
                    this.setViewportContainerDim()
                })
            })
        },
        beforeDestroy() {
            clearInterval(this._interval)
        },
        methods: {
            setViewportContainerDim() {
                if (this.$root.env !== 'renderer') {
                    this.dimm.width = this.$el.clientWidth;
                    this.dimm.maxWidth = this.$el.clientWidth;
                    this.dimm.height = this.$el.clientHeight;
                    let headerHeight = document.querySelector('.top-headers-wrapper')?.clientHeight;
                    this.dimm.height = window.innerHeight - 60 - (headerHeight ? headerHeight : 0)
                    this.dimm.maxHeight = window.screen.availHeight - (headerHeight ? headerHeight : 0)
                } else {
                    // this.dimm.width = document.documentElement.scrollWidth;
                    // this.dimm.maxWidth = document.documentElement.scrollWidth;
                    // this.dimm.height = document.documentElement.scrollHeight;
                    // this.dimm.maxHeight = document.documentElement.scrollHeight
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .lm-viewport {
        transition: all 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
        &.loaded {
        }
    }
</style>
